import React, { useEffect, useState } from 'react';
import { MenuOutlined, UserOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import { toggleDrawer } from "../../redux/actions/drawerActions";
import UserProfile from "../UserProfile/UserProfile";
import { toggleUserProfile, setUserAvatar } from '../../redux/actions/profileActions';
import { Avatar, Typography } from 'antd';
import profileClient from "../../client/ProfileClient";
import './Topbar.css';
import LanguageSelector from "../../components/LanguageSelector/LanguageSelector";
import useIsMobile from "../../hooks/useIsMobile";
import useDrawerVisible from "../../hooks/useDrawerVisible";
import useTranslation from "../../hooks/useTranslation";
import FeatureFlagUtil from "../../utils/featureFlagUtil";

const { Text } = Typography;

export default function Topbar() {
    const isMobile = useIsMobile();
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const isProfileOpen = useSelector(state => state.profile.isProfileOpen);
    const avatarUrl = useSelector(state => state.profile.avatar);
    const selectedDeck = useSelector(state => state.deck.selectedDeck);
    // Видимость, а не сам флаг: на телефоне он означает обратное, и кнопка объявляла
    // читалке «развёрнуто» при закрытом меню. Отступ заголовка колоды это не меняет —
    // правило действует от 769 пикселей, где видимость и флаг совпадают.
    const isDrawerVisible = useDrawerVisible();

    const deckTitle = selectedDeck ? selectedDeck.title : null;

    const [canShowLanguageSelector, setCanShowLanguageSelector] = useState(false);

    const handleToggleDrawer = () => {
        dispatch(toggleDrawer());
    };

    const handleToggleProfile = () => {
        dispatch(toggleUserProfile());
    };

    const avatarSrc = avatarUrl || '/assets/default-avatar.png';

    useEffect(() => {
        const fetchAvatar = async () => {
            try {
                const avatarUrl = await profileClient.getAvatar();
                dispatch(setUserAvatar(avatarUrl));
            } catch {
                // Аватара просто нет — у нового пользователя его и не было. Ставим null,
                // и Topbar покажет заглушку; сообщать тут не о чем.
                dispatch(setUserAvatar(null));
            }
        };

        fetchAvatar();
    }, [dispatch]);

    useEffect(() => {
        // Проверяем флаг "LOCALIZATION"
        FeatureFlagUtil.isFeatureEnabled("LOCALIZATION")
            .then((enabled) => {
                setCanShowLanguageSelector(enabled);
            })
            .catch((err) => {
                console.error("Failed to check LOCALIZATION feature:", err);
            });
    }, []);

    return (
        <div className="topbar">
            <div className={`topbarWrapper ${isDrawerVisible ? 'drawerOpen' : ''}`}>
                <div className="topleft logoSection">
                    <button
                        type="button"
                        className="logoButton"
                        aria-label={t('common.toggleMenu')}
                        aria-expanded={isDrawerVisible}
                        onClick={handleToggleDrawer}
                    >
                        <MenuOutlined className="menuIcon" />
                        <span className="logoText">RETRIEVE</span>
                    </button>
                    {isMobile && <div className="separator"></div>}
                    {deckTitle && (
                        <Text className="deckTitle">{deckTitle}</Text>
                    )}
                </div>
                <div className="topRight">
                    {canShowLanguageSelector && !isMobile && (
                        <div className="languageSelector">
                            <LanguageSelector />
                        </div>
                    )}
                    <Avatar
                        src={avatarSrc}
                        className="topAvatar"
                        onClick={handleToggleProfile}
                        icon={!avatarUrl && <UserOutlined />}
                    />
                    {isProfileOpen && <UserProfile />}
                </div>
            </div>
        </div>
    );
}
